// We can create consts for these so we don't have to allocate new objects every time

export const inRowConsAtType: TypePathPart = {in: 'RowCons', at: 'type'};
export const inRowConsAtTail: TypePathPart = {in: 'RowCons', at: 'tail'};
export const inTypeApplicationAtCon: TypePathPart = {
  in: 'TypeApplication',
  at: 'con',
};
export const inTypeApplicationAtArg: TypePathPart = {
  in: 'TypeApplication',
  at: 'arg',
};
export const inGeneric: TypePathPart = {in: 'Generic'};

export type TypePathPart =
  | {
      in: 'RowCons';
      at: 'type' | 'tail';
    }
  | {
      in: 'TypeApplication';
      at: 'con' | 'arg';
    }
  | {
      in: 'Generic';
    };

export type TypePath = TypePathPart[];
